// src/components/CompetencyLevelIndicator.js
// 3-segment visual indicator for graded competencies (0-3).
//
// Grade 0: all segments inactive (not expected)
// Grade 1: 1 segment filled — lightest BRIO gold
// Grade 2: 2 segments filled — progressively deeper gold
// Grade 3: 3 segments filled — deepest gold tones
//
// Each filled segment uses a progressively deeper shade of BRIO gold,
// making the grade level immediately readable at a glance.

import React from 'react';

const INACTIVE = '#E5E7EB';

// Graduated BRIO gold shades (lightest → deepest)
const GOLD_SHADES = [
  '#D6D2A8', // segment 1 — light gold
  '#B5AD60', // segment 2 — medium gold
  '#9F902A', // segment 3 — full BRIO gold
];

const GRADE_LABELS = ['Not expected', 'Supports', 'Responsible', 'Leads / approves'];

export default function CompetencyLevelIndicator({ grade = 0, size = 'default', showTooltip = true }) {
  const isSmall = size === 'small';
  const segH = isSmall ? 6 : 8;
  const segW = isSmall ? 10 : 12;
  const gap  = 2;

  const totalW = segW * 3 + gap * 2;

  const segments = [1, 2, 3].map(i => {
    const filled = i <= grade;
    return (
      <span
        key={i}
        style={{
          display: 'inline-block',
          width: segW,
          height: segH,
          borderRadius: 1,
          background: filled ? GOLD_SHADES[i - 1] : INACTIVE,
          transition: 'background 0.15s',
        }}
      />
    );
  });

  return (
    <span
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        gap,
        width: totalW,
        flexShrink: 0,
      }}
      title={showTooltip ? GRADE_LABELS[grade] || '' : undefined}
    >
      {segments}
    </span>
  );
}

export { GRADE_LABELS };
